import React from 'react';
import { FormattedMessage } from 'react-intl-next';
export var formatLabel = function formatLabel(label) {
  return typeof label === 'string' ? label : /*#__PURE__*/React.createElement(FormattedMessage, label);
};
export var formatDescription = function formatDescription(description) {
  return typeof description === 'string' ? description : description ? /*#__PURE__*/React.createElement(FormattedMessage, description) : null;
};